var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 125,
    viewBox: "0 0 79 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M6.4269 58.3851C-2.09314 48.2313 -0.768724 33.0931 9.38507 24.5731L95.182 -47.4191C105.336 -55.9392 120.474 -54.6147 128.994 -44.4609L200.986 41.336C209.506 51.4898 208.182 66.6279 198.028 75.148L112.231 147.14C102.077 155.66 86.9392 154.336 78.4191 144.182L6.4269 58.3851Z",
    fill: "#0061FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTriangle);
export default __webpack_public_path__ + "static/media/blue-triangle.a11ddd31059889bc4c589e819f8c725c.svg";
export { ForwardRef as ReactComponent };